import { Injectable } from '@angular/core';
import { CnafUserService, PageInfo, ClickInfo } from '@cnaf/ng-cnaf-commons';
import { TagXitiService as TagCommonXitiService } from '@cnaf/cnaf-commons-mon-compte-appli';
import { CnafContacterMaCafService } from './contactermacaf.service';

declare const ATInternet: any;

@Injectable()
export class TagXitiService {
  cookieName = 'appOs';
  appOs = document.cookie.replace(new RegExp(`(?:(?:^|.*;\\s*)${this.cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1');

  constructor(private readonly cnafUserService: CnafUserService,
              private readonly cnafContacterMafCafService: CnafContacterMaCafService,
              private readonly tagXitiService: TagCommonXitiService) {
    }

  getAtTagObject(
    name: string, contexte: string, chapter1?: string, chapter2?: string,
    chapter3?: string, indicateursPage?: any , indicateurSite?: any ): PageInfo {
    let level2 = '5';

    const obj: PageInfo = {
        name,
        chapter1,
        chapter2,
        chapter3,
        level2,
        customVars: {},
        /* A décommenter lorsque la version du ng-cnaf-commons sera prête (remplacer les variables en dure par les variables xldeploy)
        ,
        confSmartTag: {
          site: contexteAppel === "aripa" ? '592135' : '522955'
        }*/
    };

    if (indicateursPage != null) {
      if (typeof indicateursPage === 'number') {
        // @ts-ignore
        obj.customVars.page = {
          1: indicateursPage
        };
      } else {
        // @ts-ignore
        obj.customVars.page = indicateursPage;
      }
    }

    const codeOrga = this.cnafUserService.codeOrga;
    const matricule = this.cnafUserService.matricule;

    // 1: Utilisateur connecté  2: Non connecté
    let x1 = '1';

    if (!this.cnafContacterMafCafService.logged) {
      level2 = '4'; // Espace Ma Caf = 4
      obj.level2 = level2;
      x1 = '2';
    }

    // @ts-ignore
    obj.customVars.site = this.processCustomVarsSite(level2, codeOrga, matricule, x1);

    if (indicateurSite != null){
      // @ts-ignore
      obj.customVars.site['1'] = x1;
      // @ts-ignore
      obj.customVars.site['4'] = `[${this.cnafContacterMafCafService.clean(indicateurSite.x4)}]`;
      // @ts-ignore
      obj.customVars['site']['8'] =  chapter1;
      // @ts-ignore
      obj.customVars.site['11'] = `[${this.cnafContacterMafCafService.clean(indicateurSite.x11)}]`;
      // @ts-ignore
      obj.customVars.site['12'] = `[${this.cnafContacterMafCafService.clean(indicateurSite.x12)}]`;
      // @ts-ignore
      obj.customVars.site['13'] = `[${this.cnafContacterMafCafService.clean(indicateurSite.x13)}]`;
    }
    return obj;
  }
  getProfilutilisateur(): string {
    const profileUtilisateu: Record<string, string> = {
      "double allocataire": this.cnafUserService.CNAF_LIST_GROUP.GROUP_MULTI_AFFILIATION,
      "tuteur physique du protégé sous tutelle 4": this.cnafUserService.CNAF_LIST_GROUP.GROUP_TUTEUR_PHYSIQUE,
      "conjoint avec délégation": this.cnafUserService.CNAF_LIST_GROUP.GROUP_CONJOINTS_DELEGUES,
      "responsable dossier": this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_DOSSIER_PRINCIPAL,
      "protégé sous tutelle 4": this.cnafUserService.CNAF_LIST_GROUP.GROUP_ALLOCATAIRES_TUTELLE4,
      "enfants et autres personnes": this.cnafUserService.CNAF_LIST_GROUP.GROUP_ENFANTS_AUTRES_PERSONNES,
      "conjoint sans délégation": this.cnafUserService.CNAF_LIST_GROUP.GROUP_CONJOINTS
    }

    const listeGroupe: string[]= []

    Object.entries(profileUtilisateu).forEach(([profil, groupe]) =>{
      if(this.cnafUserService.isInGroup(groupe)){
        listeGroupe.push(profil);
      }
    })

    return listeGroupe.length > 0 ? listeGroupe.join(", ") : "inconnu";
  }


  private processCustomVarsSite(level2: string, codeOrga: string, matricule: string, statut: string): any {
    const site = this.tagXitiService.getAtTagSiteObject();
    site['1'] = statut;
    site['3'] = level2;

    if (codeOrga && matricule) {
      site['8'] = codeOrga;
    } else {
      delete site['8'];
    }
    return site;
  }

  getAtClickObject(name: string, type: string, chapter1: string, chapter2: string, chapter3: string, elem?: EventTarget): ClickInfo {

    let level2 = '5'; // Prestations - CALP

    if (!this.cnafContacterMafCafService.logged) {
      level2 = '4'; // Espace Ma Caf = 4
    }

    return {
      elem,
      name,
      level2,
      chapter1,
      chapter2,
      chapter3,
      type
    };
  }

  getAtPublisherSetObject(
    campaignId: string, creation: string, variant: string, format: string,
    detailedPlacement: string, advertiserId: string, elem?: EventTarget): any {
    return {
      elem,
      impression: {
        campaignId: `[${campaignId}]`,
        creation: `[${creation}]`,
        variant: `[${variant}]`,
        format: `[${format}]`,
        detailedPlacement: `[${detailedPlacement}]`,
        advertiserId: `[${advertiserId}]`
      }
    };
  }
  getAtClickPublisherSetObject(
    campaignId: string, creation: string, variant: string,
    format: string, detailedPlacement: string, advertiserId: string, elem?: EventTarget): any {
    return {
      elem,
      click: {
        campaignId: `[${campaignId}]`,
        creation: `[${creation}]`,
        variant: `[${variant}]`,
        format: `[${format}]`,
        detailedPlacement: `[${detailedPlacement}]`,
        advertiserId: `[${advertiserId}]`
      }
    };
  }
}
